'use client';

import React, { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

const Header: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Services', href: '#services' },
    { label: 'Process', href: '#process' },
    { label: 'Testimonials', href: '#testimonials' },
    { label: 'About', href: '#about' },
  ];

  return (
    <nav
      className={`fixed top-5 left-1/2 -translate-x-1/2 z-50 w-[92%] max-w-5xl transition-all duration-500 rounded-full px-3 py-2 flex items-center justify-between nav-pill ${
        scrolled ? 'shadow-obsidian' : ''
      }`}
    >
      {/* Logo */}
      <div className="flex items-center gap-2.5 pl-2">
        <div className="flex items-center gap-2">
          <div className="w-7 h-7 rounded-full bg-gold/15 border border-gold/30 flex items-center justify-center">
            <Icon name="PencilIcon" size={14} className="text-gold" />
          </div>
          <span className="font-display italic text-parchment text-lg leading-none">Judith Carey</span>
        </div>
      </div>

      {/* Desktop nav */}
      <div className="hidden md:flex items-center gap-1">
        {navLinks.map((link) => (
          <a
            key={link.label}
            href={link.href}
            className="px-5 py-2 text-sm font-body font-medium text-parchment/60 hover:text-parchment transition-colors duration-200 rounded-full hover:bg-white/5"
          >
            {link.label}
          </a>
        ))}
      </div>

      {/* CTA */}
      <div className="flex items-center gap-3">
        <a
          href="mailto:jc.careerwriter@gmail.com"
          className="hidden md:flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-body font-semibold text-obsidian bg-gold hover:bg-gold-light transition-all duration-300 hover:shadow-gold group"
        >
          Contact
          <Icon name="ArrowRightIcon" size={14} className="group-hover:translate-x-0.5 transition-transform" />
        </a>
        <button
          className="md:hidden text-parchment/70 p-2"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <Icon name={menuOpen ? 'XMarkIcon' : 'Bars3Icon'} size={22} />
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="absolute top-full left-0 right-0 mt-3 rounded-2xl nav-pill p-4 md:hidden">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={() => setMenuOpen(false)}
              className="block px-4 py-3 text-sm font-medium text-parchment/70 hover:text-parchment transition-colors"
            >
              {link.label}
            </a>
          ))}
          <a
            href="mailto:jc.careerwriter@gmail.com"
            onClick={() => setMenuOpen(false)}
            className="block w-full mt-2 px-5 py-3 rounded-full text-sm font-semibold text-obsidian bg-gold hover:bg-gold-light transition-all text-center"
          >
            Contact
          </a>
        </div>
      )}
    </nav>
  );
};

export default Header;